export default __webpack_public_path__ + "static/media/point_engine_logo.d78fd6c1.webp";